module.exports = __webpack_public_path__ + "static/media/pwc.791584ae.png";